import { ReactElement, SVGProps } from 'react';
import BaseIcon from "./BaseIcon";

const EventIcon = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon {...props}>
      <path d="M14.135 17.547a2.35 2.35 0 0 1-1.73-.707 2.35 2.35 0 0 1-.706-1.73q0-1.024.706-1.73a2.35 2.35 0 0 1 1.73-.706 2.35 2.35 0 0 1 1.73.706q.707.706.707 1.73a2.35 2.35 0 0 1-.707 1.73 2.35 2.35 0 0 1-1.73.707m-9.261 3.899q-.805 0-1.377-.573a1.87 1.87 0 0 1-.573-1.377V5.849q0-.805.573-1.377a1.87 1.87 0 0 1 1.377-.573h.975V1.95h1.95V3.9h7.799V1.95h1.95V3.9h.975q.803 0 1.376.573.574.573.574 1.377v13.647q0 .803-.574 1.377a1.87 1.87 0 0 1-1.376.571zm0-1.95h13.648V9.749H4.874z" fill="currentColor" />
    </BaseIcon >
  )
}
export default EventIcon;